import styled from 'styled-components';

export const DownloadButtonGrid = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: -30px;

  button {
    max-width: 200px;
  }
`;
